import React from "react";
import {
    ResponsiveContainer,
    AreaChart,
    Area,
    CartesianGrid,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";

interface Props {
    data: {
        PriceDate: string;
        Price: number;
    }[];
    color: string;
    minPrice: number;
    maxPrice: number;
}

const FuelPriceChart: React.FC<Props> = ({ data, color, minPrice, maxPrice }) => {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data}>
                <defs>
                    <linearGradient id="fuelGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop
                            offset="5%"
                            stopColor={color}
                            stopOpacity={0.25}
                        />

                        <stop
                            offset="95%"
                            stopColor={color}
                            stopOpacity={0}
                        />
                    </linearGradient>
                </defs>

                <CartesianGrid
                    strokeDasharray="3 3"
                    vertical={false}
                />

                <XAxis
                    dataKey="PriceDate"
                    tick={{ fontSize: 12 }}
                    tickFormatter={(value) => {
                        const date = new Date(value);

                        return date.toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                        });
                    }}
                />

                <YAxis
                    orientation="right"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12 }}
                    domain={[
                        Number((minPrice - 0.2).toFixed(2)),
                        Number((maxPrice + 0.2).toFixed(2)),
                    ]}
                    tickFormatter={(value) => `₹${value.toFixed(2)}`}
                />

                <Tooltip
                    formatter={(value) => {
                        const num = Number(value ?? 0);
                        return [`₹${num.toFixed(2)}`, "Price"];
                    }}
                    labelFormatter={(label) => {
                        const date = new Date(label);

                        return date.toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                        });
                    }}
                />

                <Area
                    type="monotone"
                    dataKey="Price"
                    stroke={color}
                    strokeWidth={3}
                    fill="url(#fuelGradient)"
                />
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default FuelPriceChart;